/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_RoleInputs */

const en_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const de_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle`)
};

const fr_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poste`)
};

const es_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puesto`)
};

const it_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruolo`)
};

const nl_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

const pl_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rola`)
};

const fi_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tehtävä`)
};

const da_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolle`)
};

const sv_salary_negotiate_role = /** @type {(inputs: Salary_Negotiate_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {Salary_Negotiate_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_role = /** @type {((inputs?: Salary_Negotiate_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_role(inputs)
	if (locale === "fr") return fr_salary_negotiate_role(inputs)
	if (locale === "es") return es_salary_negotiate_role(inputs)
	if (locale === "it") return it_salary_negotiate_role(inputs)
	if (locale === "nl") return nl_salary_negotiate_role(inputs)
	if (locale === "pl") return pl_salary_negotiate_role(inputs)
	if (locale === "fi") return fi_salary_negotiate_role(inputs)
	if (locale === "da") return da_salary_negotiate_role(inputs)
	if (locale === "sv") return sv_salary_negotiate_role(inputs)
	return en_salary_negotiate_role(inputs)
});